import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Save from './save';
import Edit from './edit';

registerBlockType( metadata.name, {
	edit: Edit,
	save: Save,
	icon: {
		foreground: '#0061FE',
		src: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="24"
				height="24"
			>
				<path d="M4 4.5C4 3.7 4.7 3 5.5 3h13c.8 0 1.5.7 1.5 1.5v15c0 .8-.7 1.5-1.5 1.5h-13C4.7 20 4 19.3 4 18.5v-15ZM5.5 4.5v14h13v-14h-13Z" />
				<rect x="7" y="6.5" width="10" height="5" rx=".7" opacity=".4" />
				<rect x="7" y="13" width="7" height="1.2" rx=".6" />
				<rect x="7" y="15.5" width="10" height="1" rx=".5" opacity=".3" />
				<rect x="7" y="17.5" width="8" height="1" rx=".5" opacity=".3" />
			</svg>
		),
	},
} );
